<template>
  <item-base
    :action="logut"
    icon="box-arrow-left"
  >
    ログアウト
  </item-base>
</template>

<script>
import ItemBase from './Base'

export default {
  components: {
    ItemBase
  },

  methods: {
    logut () {
      const result = this.$store.dispatch('user/logout')
      if (result) this.$router.push({ name: 'login' })
    }
  }
}
</script>
